import {FunctionComponent, HTMLAttributes} from 'react';

type Props = HTMLAttributes<HTMLDivElement>;

const ContainerCardContent: FunctionComponent<Props> = ({children, ...props}) => {
  return (
    <div className="mt-14" {...props}>
      {children}
    </div>
  );
};

export default ContainerCardContent;
